<template>
  <div :class="containerClass">
    <label class="field-label">{{ label }}{{ hasRequiredLabel && required ? '*' : '' }}</label>
    <QSelect
      v-model="localValue"
      ref="field"
      outlined
      :placeholder="placeholder"
      :options="options"
      :option-value="optionValue"
      :option-label="optionLabel"
      :rules="getRules()"
      v-on:blur="onBlur()"
      :readonly="readonly"
      lazy-rules
      :disable="disable"
      :clearable="clearable"
    />
  </div>
</template>

<script>
import { QSelect } from 'quasar';
/**
 * This component represents common UI for an input field with label
 */
export default {
  name: 'SelectField',
  props: {
    label: String,
    placeholder: String,
    required: Boolean,
    value: {
      type: Object,
      default: () => {}
    },
    type: String,
    readonly: Boolean,
    options: Array,
    optionLabel: String,
    optionValue: String,
    clearable: {
      type: Boolean,
      default: true
    },
    containerClass: {
      type: String,
      default: 'q-pa-xs col-12 col-sm-6'
    },
    disable: {
      type: Boolean,
      default: false
    },
    hasRequiredLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localValue: '',
      validate: false
    };
  },
  methods: {
    onBlur: function () {
      this.validate = true;
      this.$refs.field.validate();
    },
    getRules: function () {
      const rules = [];
      const FIELD_REQUIRED_MESSAGE = 'Field is required';

      if (this.required) {
        rules.push((val) => {
          if (this['option-value']) {
            const optionValue = val[this['option-value']];

            return !optionValue || optionValue == '' ? FIELD_REQUIRED_MESSAGE : true;
          } else if (!val || val == '') {
            return FIELD_REQUIRED_MESSAGE;
          }

          return true;
        });
      }

      return rules;
    }
  },
  watch: {
    localValue(value) {
      this.$emit('input', value);
    }
  },
  created() {
    this.localValue = this.value;
  },
  components: { QSelect }
};
</script>
